"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var moment_1 = tslib_1.__importDefault(require("react-day-picker/moment"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var DateConversions_1 = require("../utils/DateConversions");
var DateRangePickerInputField_1 = require("./DateRangePickerInputField");
var utils_1 = require("./utils");
var DateRangePickerError_1 = require("./DateRangePickerError");
var DateRangePickerInputFieldBody_1 = require("./DateRangePickerInputFieldBody");
var DateRangePickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateRangePickerComponent, _super);
    function DateRangePickerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromInputRef = react_1.default.createRef();
        _this.toInputRef = react_1.default.createRef();
        _this.focusField = function (inputRef) {
            if (inputRef.current) {
                // Focus needs to happen on the next tick otherwise the day picker is not updated
                setTimeout(function () {
                    inputRef.current.getInput().focus();
                }, 0);
            }
        };
        _this.blurField = function (inputRef) {
            if (inputRef.current) {
                inputRef.current.getInput().blur();
            }
        };
        _this.updateRange = function (from, to) {
            _this.props.onRangeChange({ from: from, to: to });
        };
        _this.handleFromDayClick = function () {
            _this.focusField(_this.toInputRef);
        };
        _this.handleToDayClick = function (to) {
            var rangeBoundsCrossed = utils_1.areRangeBoundsCrossed(_this.props.range.from, to);
            if (to && !rangeBoundsCrossed) {
                _this.blurField(_this.toInputRef);
            }
            else if (rangeBoundsCrossed) {
                _this.focusField(_this.fromInputRef);
            }
        };
        _this.getSanitizedInputValue = function (inputRef, date) {
            var inputValue = inputRef.current && inputRef.current.getInput().value;
            return !date && !inputValue ? null : date;
        };
        _this.handleFromChange = function (from) {
            var useFrom = from && _this.props.range.to && utils_1.areRangeBoundsCrossed(from, _this.props.range.to);
            var to = useFrom ? from : _this.props.range.to;
            var sanitizedFrom = _this.getSanitizedInputValue(_this.fromInputRef, from);
            _this.updateRange(sanitizedFrom, to);
        };
        _this.handleToChange = function (to) {
            var useTo = to && _this.props.range.from && utils_1.areRangeBoundsCrossed(_this.props.range.from, to);
            var from = useTo ? to : _this.props.range.from;
            var sanitizedTo = _this.getSanitizedInputValue(_this.toInputRef, to);
            _this.updateRange(from, sanitizedTo);
        };
        return _this;
    }
    DateRangePickerComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, dateFormat = _a.dateFormat, _b = _a.range, from = _b.from, to = _b.to, dayPickerProps = _a.dayPickerProps, intl = _a.intl, isMobile = _a.isMobile, _c = _a.errors, _d = _c === void 0 ? { from: undefined, to: undefined } : _c, errorFrom = _d.from, errorTo = _d.to;
        var defaultDayPickerProps = {
            showOutsideDays: true,
            modifiers: { start: from, end: to },
            selectedDays: [from, { from: from, to: to }],
            locale: util_1.translationUtils.sanitizeLocaleForMoment(intl.locale),
            localeUtils: moment_1.default,
        };
        var dayPickerPropsWithDefaults = utils_1.mergeDayPickerProps(defaultDayPickerProps, dayPickerProps);
        var FromField = isMobile ? (react_1.default.createElement(DateRangePickerInputFieldBody_1.DateRangePickerInputFieldBody, { type: "date", className: classnames_1.default("s-date-range-picker-from", "gd-date-range-picker-input", "gd-date-range-picker-input-native", errorFrom && "gd-date-range-picker-input-error"), placeholder: intl.formatMessage({ id: "filters.from" }), onChange: function (event) {
                return _this.handleFromChange(DateConversions_1.convertPlatformDateStringToDate(event.target.value));
            }, value: DateConversions_1.convertDateToPlatformDateString(from) })) : (react_1.default.createElement(DateRangePickerInputField_1.DateRangePickerInputField, { className: classnames_1.default("s-date-range-picker-from", errorFrom && "gd-date-range-picker-input-error"), classNameCalendar: "s-date-range-calendar-from", ref: this.fromInputRef, onDayChange: this.handleFromChange, value: from || "", format: dateFormat, placeholder: intl.formatMessage({ id: "filters.from" }), dayPickerProps: tslib_1.__assign(tslib_1.__assign({}, dayPickerPropsWithDefaults), { onDayClick: this.handleFromDayClick }) }));
        var ToField = isMobile ? (react_1.default.createElement(DateRangePickerInputFieldBody_1.DateRangePickerInputFieldBody, { type: "date", className: classnames_1.default("s-date-range-picker-to", "gd-date-range-picker-input", "gd-date-range-picker-input-native", errorTo && "gd-date-range-picker-input-error"), placeholder: intl.formatMessage({ id: "filters.to" }), onChange: function (event) { return _this.handleToChange(DateConversions_1.convertPlatformDateStringToDate(event.target.value)); }, value: DateConversions_1.convertDateToPlatformDateString(to) })) : (react_1.default.createElement(DateRangePickerInputField_1.DateRangePickerInputField, { className: classnames_1.default("s-date-range-picker-to", errorTo && "gd-date-range-picker-input-error"), classNameCalendar: "s-date-range-calendar-to", ref: this.toInputRef, onDayChange: this.handleToChange, value: to || "", format: dateFormat, placeholder: intl.formatMessage({ id: "filters.to" }), dayPickerProps: tslib_1.__assign(tslib_1.__assign({}, dayPickerPropsWithDefaults), { onDayClick: this.handleToDayClick }) }));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "gd-date-range-picker s-date-range-picker" },
                FromField,
                react_1.default.createElement("span", { className: "gd-date-range-picker-dash" }, "\u2014"),
                ToField),
            (errorFrom || errorTo) && (react_1.default.createElement(DateRangePickerError_1.DateRangePickerError, { dateFormat: dateFormat, errorId: 
                // This means that when both inputs are invalid, error is shown only for "from"
                errorFrom || errorTo }))));
    };
    return DateRangePickerComponent;
}(react_1.default.Component));
exports.DateRangePicker = react_intl_1.injectIntl(DateRangePickerComponent);
//# sourceMappingURL=DateRangePicker.js.map